import Vue from 'vue';
import locale from '../../node_modules/element-ui/lib/locale'; //用elementui需要引入，其他不需要
import VueI18n from 'vue-i18n';
import messages from './lang';

Vue.use(VueI18n);
let i18n;
window.onmessage = function (event) {
    console.log(event,"dfsdfgjw");
    if (event.data && typeof event.data === 'string' && window.self !== window.top) {
        localStorage.setItem('language', event.data);
        i18n.locale = localStorage.getItem('language'),
        locale.i18n((key, value) => i18n.t(key, value))
    }
}

// 从localStorage中拿到用户的语言选择，如果没有，那就默认中文
var language = localStorage.getItem('language');
console.log(language,'dksfhsjkfdsjkdf')
i18n = new VueI18n({
    locale: language || localStorage.lang || 'zh',
    messages
})
locale.i18n((key, value) => i18n.t(key, value))
// 刷新浏览器是初始化默认语言 把当前语言写缓存，其它地方都先从缓存获取语言
localStorage.setItem('language', i18n.locale)
export default i18n